// extracted by mini-css-extract-plugin
export default {"column":"_1R_Yq","divider":"tngTG"};